// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"496":"97b44d3e","498":"09342aea","513":"02b2f62f","703":"fcffe270"}[chunkId] + ".chunk.js";
};